import { useContext } from 'react';
import { MoveObjectContext } from '../Context';

export const useMoveObjectContext = () => {
  const ctx = useContext(MoveObjectContext);

  return ctx;
};

export default useMoveObjectContext;